module.exports = __webpack_public_path__ + "img/IMG_1231_L_WoodMatted_MockedUp.9534f1b4.jpg";